const reception = [
  {
    path: '/reception/filter',
    name: 'receptionFilter',
    component: () => import('@/mobile/page/reception/filter'),
    meta: {
      name: '필터',
    },
  },
  {
    path: '/reception/approval',
    component: () => import('@/mobile/page/reception/approval'),
    meta: {
      name: '결재 승인 완료',
    },
  },
  {
    path: '/reception/reject',
    component: () => import('@/mobile/page/reception/reject'),
    meta: {
      name: '결재 반려 완료',
    },
  },
  {
    path: '/reception/mealcost/:id',
    name: 'MobileReceptionMealcost',
    component: () => import('@/mobile/page/reception/mealcost'),
    meta: {
      name: '식대비',
    },
  },
  {
    path: '/reception/expense/:id',
    name: 'MobileReceptionExpense',
    component: () => import('@/mobile/page/reception/expense'),
    meta: {
      name: '지출결의서',
    },
  },
  {
    path: '/reception/businesstrip/:id',
    name: 'MobileReceptionBusinesstrip',
    component: () => import('@/mobile/page/reception/businesstrip'),
    meta: {
      name: '출장결과보고서',
    },
  },
  {
    path: '/reception/holidaywork/:id',
    name: 'MobileReceptionHolidaywork',
    component: () => import('@/mobile/page/reception/holidaywork'),
    meta: {
      name: '휴일근무',
    },
  },
  {
    path: '/reception/admit/:id',
    name: 'MobileReceptionAdmit',
    component: () => import('@/mobile/page/reception/admit'),
    meta: {
      name: '인정휴가 지급',
    },
  },
  {
    path: '/reception/vacation/:id',
    component: () => import('@/mobile/page/reception/vacation'),
    meta: {
      name: '휴가',
    },
  },
  {
    path: '/reception/submit/:id',
    name: 'MobileReceptionSumit',
    component: () => import('@/mobile/page/reception/submit'),
    meta: {
      name: '품의서',
    },
  },
  {
    path: '/reception/result',
    component: () => import('@/mobile/page/reception/result'),
    meta: {
      name: '결재 결과',
    },
  },
];

export default reception;
